<!-- 订单详情 -->
<template>
	<div class="wrap">

		<div class="header">
			<img src="../assets/back-icon7.png" class="return-img" @click="$router.back()">
			<p class="header-title">订单详情</p>
		</div>
		
		<!-- 待收货显示 -->
		<!-- <div class="head">
			<span class="status-text">已发货等待收货</span>
			<img src="../assets/status-1.png" class="status-img">
		</div> -->
		<!-- 待付款显示 -->
		<div class="head">
			<div class="head-column">
				<span class="status-text">等待买家付款</span>
				<p class="time-row">
					<img src="../assets/time.png" class="time-icon">
					<span>剩余23小时44分钟</span>
				</p>
			</div>

			<img src="../assets/status-2.png" class="status-img">
		</div>

		<div class="address-box">
			<img src="../assets/icon-75.png" class="location-icon">
			<div class="address-box-sidebar">
				<p class="user-message">
					章鱼小丸子
					<span>18790653414</span>
				</p>
				<p class="address-msg">北京市昌平区天通苑北街道天通苑北一区</p>
			</div>
		</div>

		<div class="product-module">
			<div class="product-box">
				<img src="../assets/img.png" class="product-img">
				<div class="product-box-sidebar">
					<div class="product-box-sidebar-left">
						<p class="product-name">TX36系列 开发板</p>
						<p class="product-msg">K1T_TPC7908_XS</p>
					</div>
					<div class="product-box-sidebar-right">
						<p class="product-price">
							¥<span>344</span>
						</p>
						<span class="product-num">X1</span>
					</div>
				</div>
			</div>
			<div class="product-row-between">
				<span class="font-1">邮费</span>
				<span class="font-1">包邮</span>
			</div>
			<div class="product-row-between">
				<span class="font-1">优惠券</span>
				<span class="font-2">无可用优惠</span>
			</div>
			<div class="product-row-between">
				<span class="font-1">订单总金额</span>
				<p class="product-price">
					¥<span>344</span>
				</p>
			</div>
			<div class="row-end">
				<span class="actual-payment-name">实付款</span>
				<span class="actual-payment">¥<span>344</span></span>
			</div>
		</div>

		<div class="msg-wrap">
			<div class="product-row-between">
				<span class="font-1">订单编号</span>
				<span class="font-1">
					127278191377881938818
					<img src="../assets/icon-76.png" class="copy-img">
				</span>
			</div>
			<div class="product-row-between">
				<span class="font-1">创建时间</span>
				<span class="font-1">2022-06-11 12:00</span>
			</div>
			<div class="product-row-between">
				<span class="font-1">支付方式</span>
				<span class="font-1">微信支付</span>
			</div>
			<!-- 待收货显示 -->
			<div class="product-row-between">
				<span class="font-1">付款时间</span>
				<span class="font-1">2022-06-11 12:00</span>
			</div>
			<div class="product-row-between">
				<span class="font-1">发货时间</span>
				<span class="font-1">2022-06-11 12:00</span>
			</div>
		</div>

		<div class="box-between">
			<div class="box-left">
				<img src="../assets/icon-77.png">
				联系客服
			</div>
			<span class="box-right">每天09:00-23:00</span>
		</div>

		<div class="footer">
			<div class="footer-sidebar">
				<!-- 待付款显示 -->
				<button type="button" class="footer-btn border">取消订单</button>
				<button type="button" class="footer-btn">立即付款</button>
				
				<!-- 待收货显示 -->
				<button type="button" class="footer-btn">确认收货</button>
			</div>
		</div>

	</div>
</template>

<script>
	export default {
		components: {},
		data() {
			return {

			};
		},
		mounted() {

		},
		methods: {

		}
	}
</script>

<style scoped>
	.wrap {
		width: 100%;
		min-height: 100vh;
		background-color: #F4F4F4;
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: 44px 0 83px;
		box-sizing: border-box;
	}

	/* 头部样式 */
	.header {
		width: 100%;
		height: 44px;
		display: flex;
		justify-content: center;
		align-items: center;
		position: fixed;
		top: 0;
		left: 0;
		background-color: #2A63F3;
		z-index: 999;
	}

	.return-img {
		position: absolute;
		left: 15px;
		top: 50%;
		transform: translate(0, -50%);
		width: 20px;
	}

	.header-title {
		color: #FFFFFF;
		font-size: 18px;
		font-weight: 500;
	}

	.head {
		width: 100%;
		height: 79px;
		background-color: #2A63F3;
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 0 70px 0 30px;
		box-sizing: border-box;
	}

	.status-text {
		color: #FFFFFF;
		font-size: 18px;
		font-weight: bold;
	}

	.status-img {
		width: 32px;
	}

	.address-box {
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;
		height: 98px;
		background-color: #FFFFFF;
		padding: 0 15px;
		box-sizing: border-box;
		margin-bottom: 10px;
	}

	.location-icon {
		width: 26px;
		margin-right: 10px;
	}

	.address-box-sidebar {
		flex: 1;
		display: flex;
		flex-direction: column;
	}

	.user-message {
		color: #333333;
		font-size: 15px;
		font-weight: bold;
	}

	.user-message>span {
		margin-left: 5px;
		font-size: 14px;
	}

	.address-msg {
		width: 100%;
		display: -webkit-box;
		-webkit-line-clamp: 1;
		overflow: hidden;
		text-overflow: ellipsis;
		-webkit-box-orient: vertical;
		color: #333333;
		font-size: 13px;
		margin-top: 10px;
	}

	.product-module {
		width: 100%;
		display: flex;
		flex-direction: column;
		padding: 15px;
		box-sizing: border-box;
		background-color: #FFFFFF;
		margin-bottom: 10px;
	}

	.product-module-label {
		color: #222222;
		font-size: 16px;
		font-weight: bold;
		margin-bottom: 14px;
	}

	.product-box {
		width: 100%;
		display: flex;
		align-items: center;
		margin-bottom: 11px;
	}

	.product-img {
		width: 80px;
		height: 80px;
		border-radius: 8px;
		margin-right: 10px;
	}


	.product-box-sidebar {
		flex: 1;
		height: 80px;
		display: flex;
		justify-content: space-between;
		align-items: flex-start;
		padding: 3px 0;
		box-sizing: border-box;
	}

	.product-box-sidebar-left {
		flex: 1;
		display: flex;
		flex-direction: column;
	}

	.product-name {
		width: 100%;
		color: #222222;
		font-size: 14px;
		margin-bottom: 4px;
	}

	.product-msg {
		width: 100%;
		color: #999999;
		font-size: 10px;
	}

	.product-box-sidebar-right {
		display: flex;
		flex-direction: column;
		align-items: flex-end;
	}

	.product-price {
		font-size: 10px;
		font-weight: bold;
		color: #333333;
		margin-bottom: 4px;
	}

	.product-price>span {
		font-size: 16px;
	}

	.product-num {
		color: #999999;
		font-size: 10px;
	}

	.msg-wrap {
		width: 100%;
		display: flex;
		flex-direction: column;
		background-color: #FFFFFF;
		padding: 15px;
		box-sizing: border-box;
		margin-bottom: 10px;
	}

	.product-row-between {
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 15px;
	}

	.product-row-between:last-child {
		margin-bottom: 0;
	}

	.font-1 {
		display: flex;
		align-items: center;
		color: #333333;
		font-size: 13px;
	}

	.font-2 {
		color: #999999;
		font-size: 13px;
	}

	.font-3 {
		flex: 1;
		text-align: right;
		font-size: 13px;
		color: #333333;
		display: -webkit-box;
		-webkit-line-clamp: 1;
		overflow: hidden;
		text-overflow: ellipsis;
		-webkit-box-orient: vertical;
	}

	.row-end {
		width: 100%;
		display: flex;
		justify-content: flex-end;
		align-items: center;
		padding-top: 15px;
		border-top: 1px solid #F4F4F4;
		box-sizing: border-box;
	}

	.actual-payment-name {
		font-size: 14px;
		color: #222222;
		margin-right: 4px;
	}

	.actual-payment {
		color: #FF4D58;
		font-size: 10px;
	}

	.actual-payment>span {
		font-size: 16px;
		font-weight: bold;
	}

	.footer {
		width: 100%;
		height: 83px;
		position: fixed;
		bottom: 0;
		left: 0;
		z-index: 999;
		background-color: #FFFFFF;
		display: flex;
		align-items: flex-start;
		padding: 8px 15px 0;
		box-sizing: border-box;
	}

	.footer-sidebar {
		flex: 1;
		display: flex;
		justify-content: flex-end;
		align-items: center;
	}

	.total-row {
		color: #222222;
		font-size: 10px;
	}

	.total-money {
		color: #FF4954;
		font-size: 14px;
		font-weight: bold;
		margin-left: 4px;
	}

	.total-money>span {
		font-size: 24px;
	}

	.footer-btn {
		width: 94px;
		height: 34px;
		line-height: 34px;
		border-radius: 50px;
		background-color: #2A63F3;
		color: #FFFFFF;
		font-size: 15px;
		margin-left: 16px;
	}

	.footer-btn.border {
		border: 1px solid #979797;
		background-color: #FFFFFF;
		color: #444444;
	}

	.copy-img {
		width: 14px;
		margin-left: 2px;
	}

	.box-between {
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 12px 15px;
		box-sizing: border-box;
		background-color: #FFFFFF;
		margin-bottom: 10px;
	}

	.box-left {
		font-size: 14px;
		color: #222222;
		display: flex;
		align-items: center;
	}

	.box-left>img {
		width: 22px;
		margin-right: 2px;
	}

	.box-right {
		color: #444444;
		font-size: 13px;
	}

	.head-column {
		flex: 1;
		display: flex;
		flex-direction: column;
	}

	.time-row {
		display: flex;
		align-items: center;
		color: #FFFFFF;
		font-size: 12px;
		margin-top: 9px;
	}

	.time-icon {
		width: 18px;
		margin-right: 8px;
	}
</style>
